var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElasticBand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 10.5C21.25 8.84315 17.1086 7.5 12 7.5C6.89137 7.5 2.75 8.84315 2.75 10.5M21.25 10.5V13.5C21.25 15.1569 17.1086 16.5 12 16.5C6.89137 16.5 2.75 15.1569 2.75 13.5V10.5M21.25 10.5C21.25 11.0464 20.7996 11.5587 20.0125 12M2.75 10.5C2.75 11.0464 3.20045 11.5587 3.98749 12M3.98749 12C5.58686 12.8967 8.5762 13.5 12 13.5C15.4238 13.5 18.4131 12.8967 20.0125 12M3.98749 12C5.58686 11.1033 8.57619 10.5 12 10.5C15.4238 10.5 18.4131 11.1033 20.0125 12",
    stroke: "#191C1E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticBand);
export default __webpack_public_path__ + "static/media/elasticBand.556c835767c10e7241b23597ae4e1719.svg";
export { ForwardRef as ReactComponent };